import { getSvgSelected, getSvgNonSelected, getSvgSomeSelected } from 'utils/domElements';

export default function HeaderCellCheckbox(params) {
    const { checkbox, column, context } = params;
    if (!checkbox) return null;

    let colId = column.colId;
    let checkedRowsList = [];

    if (context?.checkboxData?.[colId]?.rows) {
        checkedRowsList =
            Object.keys(context.checkboxData[colId].rows).filter(
                (current) => context.checkboxData[colId].rows[current],
            ) || [];
    }

    const isDisabled = (checkbox.isDisabled && checkbox.isDisabled(colId)) || false;
    let isChecked = checkedRowsList.length > 0 || false;
    let areAllChecked = false;

    if (context.checkboxData?.[colId]) {
        areAllChecked = context.checkboxData?.[colId]?.areAllChecked || false;
    }

    const tableId = context?.tableId || '';

    const svg = getSvg(isChecked, areAllChecked, tableId, colId);

    const cell = document.createElement('div');
    cell.classList.add('w5-header-cell-checkbox');
    if (isDisabled) cell.classList.add('w5-header-cell-checkbox--disabled');

    if (!params.useDragColumns && params.useDragRows && params?.checkbox?.onClick) {
        cell.classList.add('w5-header-cell-checkbox__align-with-rows');
    }

    if (!svg) return cell;

    if (checkbox.onClick) {
        svg.addEventListener(
            'click',
            handleOnChange(
                cell,
                svg,
                colId,
                isChecked,
                areAllChecked,
                isDisabled,
                checkbox.onClick,
                context,
                column,
                tableId,
            ),
        );
    }

    cell.appendChild(svg);

    return cell;
}

const getSvg = (isChecked, areAllChecked, tableId, colId) => {
    const svgContainer = document.createElement('div');
    svgContainer.classList.add('w5-header-cell-checkbox__svg-container');

    if (areAllChecked) {
        const svgSelected = getSvgSelected(tableId, colId);
        if (!svgSelected) return null;
        svgContainer.innerHTML = svgSelected;
    } else if (isChecked) {
        const svgSomeSelected = getSvgSomeSelected(tableId, colId);
        if (!svgSomeSelected) return null;
        svgContainer.innerHTML = svgSomeSelected;
    } else {
        const svgNonSelected = getSvgNonSelected(tableId, colId);
        if (!svgNonSelected) return null;
        svgContainer.innerHTML = svgNonSelected;
    }
    return svgContainer;
};

const handleOnChange =
    (cell, svg, colId, isChecked, areAllChecked, isDisabled, onClick, context, column, tableId) =>
    (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (isDisabled) return;

        if (!isChecked && !areAllChecked) {
            isChecked = true;
            areAllChecked = true;
        } else if (isChecked && !areAllChecked) {
            isChecked = false;
        } else if (isChecked && areAllChecked) {
            isChecked = false;
            areAllChecked = false;
        }

        svg.remove();
        const newSvg = getSvg(isChecked, areAllChecked, tableId, colId);
        if (!newSvg) return null;

        newSvg.addEventListener(
            'click',
            handleOnChange(
                cell,
                newSvg,
                colId,
                isChecked,
                areAllChecked,
                isDisabled,
                onClick,
                context,
                column,
                tableId,
            ),
        );
        cell.appendChild(newSvg);

        onClick({ colId, boolean: areAllChecked, context, column });
    };
